import { CustomerContact } from '../types'
import { isPrimaryBillingContact } from './contactPurposes'

export function getPrimaryBillingContact(
  contacts: Partial<CustomerContact>[]
): Partial<CustomerContact> | undefined {
  const primaryBillingContact = contacts.find(isPrimaryBillingContact)

  return primaryBillingContact
}
